import { Badge, Td } from '@apollo/orbit';
import React from 'react';

export const BadgeCell = ({
  text,
  variant,
}: {
  text: string;
  variant: 'brandedLight' | 'neutralOutlined' | 'success' | 'warn' | 'error';
}) => (
  <Td>
    <Badge variant={variant}>{text}</Badge>
  </Td>
);
